var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "navbar-wrapper text-nowrap" },
    [
      _c(
        "b-navbar",
        {
          staticClass: "z-depth-1 navbar-expand-sm",
          attrs: { toggleable: "", variant: "faded", fixed: "top" }
        },
        [
          _vm.isExpert || _vm.isAdmin
            ? _c(
                "b-link",
                { staticClass: "navbar-brand", attrs: { to: "/" } },
                [
                  _c("img", {
                    attrs: {
                      alt: "Future Talents",
                      src: require("@/assets/images/logo.png"),
                      height: "45"
                    }
                  })
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-navbar-nav",
            [
              _vm.isExpert || _vm.isAdmin
                ? _c("b-nav-item", { attrs: { to: "/" } }, [
                    _vm._v("\n                Időpontjaim\n            ")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isExpert || _vm.isAdmin
                ? _c("b-nav-item", { attrs: { to: "/utobbi1honap" } }, [
                    _vm._v("\n                Utóbbi 1 hónap\n            ")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isExpert || _vm.isAdmin
                ? _c("b-nav-item", { attrs: { to: "/adataim" } }, [
                    _vm._v("\n                Fogadási órák\n            ")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isExpert || _vm.isAdmin
                ? _c("b-nav-item", { attrs: { to: "/szabadsagok" } }, [
                    _vm._v("\n                Szabadságok\n            ")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isAdmin
                ? _c("b-nav-item", { attrs: { to: "/tanacsadok" } }, [
                    _vm._v("\n                Tanácsadók\n            ")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isAdmin
                ? _c("b-nav-item", { attrs: { to: "/allasok" } }, [
                    _vm._v("\n                Állások\n            ")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isAdmin
                ? _c("b-nav-item", { attrs: { to: "/jelentkezesek" } }, [
                    _vm._v("\n                Jelentkezések\n            ")
                  ])
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-navbar-nav",
            { staticClass: "ml-auto" },
            [
              _c(
                "b-nav-item",
                {
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      return _vm.logoutButton()
                    }
                  }
                },
                [_vm._v("\n                Kijelentkezés\n            ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition",
        {
          attrs: { name: "slide-down" },
          on: { enter: _vm.onShowNavMessage, leave: _vm.onHideNavMessage }
        },
        [
          _vm.showNavMessages
            ? _c(
                "div",
                { staticClass: "py-1 c-mb-15 nav-message" },
                _vm._l(_vm.navMessages, function(navMessage, index) {
                  return _c("div", { key: index, staticClass: "px-3" }, [
                    _c("span", {
                      domProps: { innerHTML: _vm._s(navMessage.message) }
                    })
                  ])
                }),
                0
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "nav-message-proxy" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }